import { Component, OnInit, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';
import { AlertController, LoadingController } from '@ionic/angular';
import { ApiserviceService } from '../../../httpservice/apiservice.service';
import { AppService } from '../../../services/app.service';
import * as saveAs from "file-saver";
import { errMsg } from '../../../text_control/error-msg';
import { _getStorage } from 'src/app/utils/local-storage';
import { STORAGE } from 'src/app/constant/storages';

@Component({
  selector: 'app-external-report',
  templateUrl: './external-report.component.html',
  styleUrls: ['./external-report.component.scss'],
})
export class ExternalReportComponent implements OnInit {
  Active = 1;
  version_string: any = this.appService.versionString;
  startDate: string = "";
  endDate: string = "";
  bu: string = "";
  loc: string = "";
  invoice_no: string = "";
  abb: string = "";

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";


  constructor(
    public appService: AppService,
    public loadingController: LoadingController,
    public router: Router,
    private apiService: ApiserviceService,
    private alert: AlertController
  ) {}

  ngOnInit() {}

  ionViewDidEnter() {
    this.userID = _getStorage(STORAGE.userID)
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    
    if (this.userRole !== "ETAXSUPERADMIN" && this.userRole !== "SUPERADMIN") {
      this.router.navigate(["home"]);
    }
  }

  goHomePage(){
    this.router.navigate(["/home"]);
  }
 
  getDateString(date: string) {
    let d = new Date(date);
    return `${d.getFullYear()}-${d.getMonth() + 1 < 10 ? `0` + (d.getMonth() + 1) : (d.getMonth() + 1)}-${d.getDate() < 10 ? `0` + d.getDate() : d.getDate()}`;
  }

  splitStringToArray(text: string) {
    if (text.indexOf(',') > -1) return text.split(',');
    if (text != "") return [text];
    return [];
  }

  validateRequest() {
    const result = {
      isNotEmpty: true,
      errMessage: ""
    }

    if (this.startDate == null || this.startDate == "") {
      result.isNotEmpty = false;
      result.errMessage = 'Require Start Date.';
      return result;
    }

    if (this.endDate == null || this.endDate == "") {
      result.isNotEmpty = false;
      result.errMessage = 'Require End Date.';
      return result;
    }

    let start = new Date(this.startDate).getTime();
    let end = new Date(this.endDate).getTime();
    if (start > end) {
      result.isNotEmpty = false;
      result.errMessage = 'Start date cannot more than End date.';
      return result;
    }

    return result;
  }

  async generateReport() {

    let validateReq = this.validateRequest();
    if (!validateReq.isNotEmpty) {
      this.errorMsg(validateReq.errMessage)
      return;
    }

    let reqBody = {
      startdate: this.getDateString(this.startDate) + ' 00:00:00',
      enddate: this.getDateString(this.endDate) + ' 23:59:59',
      bu: this.splitStringToArray(this.bu),
      loc: this.splitStringToArray(this.loc),
      invoice_no: this.splitStringToArray(this.invoice_no),
      abb: this.splitStringToArray(this.abb),
    };
    console.log('[generateReport] reqBody : ', reqBody);

    let url = this.apiService.apiUrl + this.apiService.externalReportCSV;
    try {
      this.apiService._post(url, reqBody).then(async (res: any) => {
        console.log('[generateReport] response : ', res);

        if (res.result === 'S' && res.statusCode === 200) {
          // await this.saveFile(res.data);
          await this.saveCSV(res.data);
        } else {
          this.errorMsg(res.statusMessage)
        }

      })
    } catch (error) {
      // this.errorMsg(errMsg.error)

    }
  }

  async saveCSV(csv) {
    let d = new Date().getTime().toString();
    const fileName = `REPORT_${this.getDateString(this.startDate)}_${this.getDateString(this.endDate)}_${d.slice(d.length - 5, d.length)}`;

    var uri = 'data:text/csv;charset=utf-8,' + csv;

    var downloadLink = document.createElement("a");
    downloadLink.href = uri;
    downloadLink.download = `${fileName}.csv`;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  async errorMsg(message: string) {
    let alert = await this.alert.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }
}
